import { DashboardWalletsPage, Row } from '@ppay/client'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { routes } from '../../router'
import { Breadcrumb, Breadcrumbs } from '../../layout'

export const Page = () => {
  const { t } = useTranslation('routes')

  return (
    <>
      <Row>
        <Breadcrumbs>
          <Breadcrumb link={routes.dashboard.home} name={t('home')} />
          <Breadcrumb name={t('wallets')} />
        </Breadcrumbs>
      </Row>
      <DashboardWalletsPage
        replenishPath={routes.dashboard.replenish}
        withdrawPath={routes.dashboard.withdraw}
        transactionsPath={routes.dashboard.transactions}
      />
    </>
  )
}
